import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/i18n";
import { PageHeader } from "@/components/StatCard";
import Seo from "@/components/Seo";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ChevronLeft } from "lucide-react";
import { BookingsListTab } from "@/pages/coach/bookings/BookingsListTab";
import { RescheduleTab } from "@/pages/coach/bookings/RescheduleTab";
import { RefundPolicyTab } from "@/pages/coach/bookings/RefundPolicyTab";

export default function Bookings() {
  const { user } = useAuth();
  const t = useT();
  if (user && user.role !== "coach") return <Navigate to="/app/circles" replace />;

  return (
    <div data-testid="coach-bookings-page">
      <Seo title={t("bk.seo")} noindex />
      <Link to="/app/coach" className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="bookings-back">
        <ChevronLeft className="h-4 w-4" /> {t("bk.back")}
      </Link>
      <PageHeader eyebrow={t("bk.eyebrow")} title={t("bk.title")} subtitle={t("bk.subtitle")} />

      <Tabs defaultValue="bookings" className="mt-2">
        <TabsList className="mb-4 flex h-auto w-full flex-wrap justify-start gap-1 bg-secondary/60 p-1">
          <TabsTrigger value="bookings" data-testid="bk-tab-bookings">{t("bk.tab_bookings")}</TabsTrigger>
          <TabsTrigger value="reschedule" data-testid="bk-tab-reschedule">{t("bk.tab_reschedule")}</TabsTrigger>
          <TabsTrigger value="refund" data-testid="bk-tab-refund">{t("bk.tab_refund")}</TabsTrigger>
        </TabsList>
        <TabsContent value="bookings"><BookingsListTab /></TabsContent>
        <TabsContent value="reschedule"><RescheduleTab /></TabsContent>
        <TabsContent value="refund"><RefundPolicyTab /></TabsContent>
      </Tabs>
    </div>
  );
}
